import Toolbar from '@mui/material/Toolbar';
import { alpha } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import TextFieldStyled from '../../TextFieldStyled';
import { Box } from '@mui/material';

export const GeneralTableToolbar = (props: EnhancedTableToolbarProps) => {
    const { numSelected, onFilter, tableToolbarSettings } = props;
    const { t } = useTranslation(tableToolbarSettings.translateNs, {
        keyPrefix: tableToolbarSettings.translatePrefix,
    });

    const bulkDelete = () => {
        // TODO: bulk delete
    };

    return (
        <Toolbar
            sx={{
                pl: { sm: 2 },
                pr: { xs: 1, sm: 1 },
                ...(numSelected > 0 && {
                    bgcolor: (theme) =>
                        alpha(
                            theme.palette.primary.main,
                            theme.palette.action.activatedOpacity
                        ),
                }),
            }}
        >
            {numSelected > 0 ? (
                <Typography
                    sx={{ flex: '1 1 100%' }}
                    color="inherit"
                    variant="subtitle1"
                    component="div"
                >
                    {t('SELECTED', { number: numSelected })}
                </Typography>
            ) : (
                <Typography
                    sx={{ flex: '1 1 100%' }}
                    variant="h6"
                    id="tableTitle"
                    component="div"
                >
                    {t('TITLE')}
                </Typography>
            )}
            {numSelected == 0 && (
                <Box sx={{ width: '200px', flex: '0 0 auto' }}>
                    <TextFieldStyled
                        label={t('SEARCH')}
                        fullWidth
                        onChange={(
                            event: React.ChangeEvent<HTMLInputElement>
                        ) => {
                            onFilter(event.target.value);
                        }}
                    />
                </Box>
            )}
            {numSelected > 0 ? (
                <Tooltip title={t('DELETE')}>
                    <IconButton onClick={bulkDelete}>
                        <DeleteIcon />
                    </IconButton>
                </Tooltip>
            ) : (
                <></>
                // <Tooltip title={t('FILTER')}>
                //     <IconButton>
                //         <FilterListIcon />
                //     </IconButton>
                // </Tooltip>
            )}
        </Toolbar>
    );
};

interface EnhancedTableToolbarProps {
    numSelected: number;
    onFilter: (searchTerm: string) => void;
    tableToolbarSettings: {
        translateNs: string;
        translatePrefix: string;
    };
}
